import React from 'react'
import { NavLink } from 'react-router-dom';
import { Col, Row, Container } from 'reactstrap'

//Assets
import reportImg from '../../../assets/image/report-success.png';

import { directUrl, homePageUrl } from '../../../helpers/Constants';


function ReportSubmittedSuccessfully() {
  return (
    <section className="lyt-section typ-report">
      <Container>
        <Row className="align-items-center justify-content-center">
          <Col xs={12} sm={12} md={10} lg={8} xl={6}>
            <div className="text-center">
              <img src={reportImg} alt="Report Submitted Successfully" />
              <h1 className="bs-heading typ-report">
                Report Submitted Successfully
              </h1>
              <p className="bs-para typ-report">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.{' '}
              </p>
              <div>
                <NavLink
                  to={`${directUrl}compliancer/login`}
                  className="bs-btn"
                >
                  back to home
                </NavLink>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ReportSubmittedSuccessfully
